import {VIDEO_CATEGORY} from '../defines/protocol';
import {IsEmptyVar, Txt2Date} from '../defines/common.func';
import {GetSubRegionByText, REGION} from '../defines/gukeo.const';
import {GetRegionByText} from '../defines/client.const';

export class Video {
  no: number;
  title: string;
  youtubeId: string;
  category: VIDEO_CATEGORY;
  bookmark: boolean;
  area1: string;
  area2: string;
  new: boolean;
  lastModified: Date;
  registered: Date;

  constructor(obj?: any) {
    this.no             = (obj && obj.no)             ?? null;
    this.title          = (obj && obj.title)          ?? null;
    this.youtubeId      = (obj && obj.youtube_id)     ?? null;
    this.category       = (obj && obj.category)       ?? null;
    this.bookmark       = (obj && !IsEmptyVar(obj.bookmark)) ? !!obj.bookmark : false;
    this.area1          = (obj && obj.area1)          ?? null;
    this.area2          = (obj && obj.area2)          ?? null;
    this.new            = (obj && obj.new)            ? !!obj.new : null;
    this.lastModified   = obj?.last_modified          ? Txt2Date(obj.last_modified) : null;
    this.registered     = obj?.registered             ? Txt2Date(obj.registered) : null;
  }
}

export class VideoStory {
  no: number;
  title: string;
  image?: string;
  imageUnselected?: string;
  regions?: number;

  constructor(obj?: any) {
    this.no               = obj?.no             ?? null;
    this.title            = obj?.title          ?? null;
    this.image            = obj?.image          ?? null;
    this.imageUnselected  = obj?.image_unselected ?? null;
    this.regions          = obj?.regions        ?? null;
  }
}
